import axios from 'axios';
import { format, subMonths } from 'date-fns';

const qs = require('qs');

const data = {
	labels: [
		'Aug 2020',
		'Sep 2020',
		'Oct 2020',
		'Nov 2020',
		'Dec 2020',
		'Jan 2021',
		'Feb 2021',
		'Mar 2021',
		'Apr 2021',
		'May 2021',
		'Jun 2021',
		'Jul 2021',
	],
	datasets: [
		{
			data: [1400, 1100, 250, 275, 350, 456, 600, 250, 0, 0, 900, 1500],
			backgroundColor: ['#F6C85F'],
		},
	],
};

const data2 = {
	labels: [
		'Aug 2020',
		'Sep 2020',
		'Oct 2020',
		'Nov 2020',
		'Dec 2020',
		'Jan 2021',
		'Feb 2021',
		'Mar 2021',
		'Apr 2021',
		'May 2021',
		'Jun 2021',
		'Jul 2021',
	],
	datasets: [
		{
			data: [333, 500, 100, 275, 350, 456, 600, 250, 0, 0, 111, 234],
			backgroundColor: ['#4198D7'],
		},
	],
};

const getChartData = async ({ setChartData }) => {
	try {
		const response = await axios({
			method: 'post',
			data: qs.stringify({
				method: 'getExternalProviderTransactions',
			}),
			withCredentials: true,
		});

		let electricData = {
			labels: [],
			datasets: [
				{
					data: [],
					backgroundColor: ['#EE9C03'],
				},
			],
		};

		let waterData = {
			labels: [],
			datasets: [
				{
					data: [],
					backgroundColor: ['#EE9C03'],
				},
			],
		};

		const rawElectricData =
			response.data.results.activities.Electric[
				Object.keys(response.data.results.activities.Electric)[0]
			];

		const rawWaterData = response.data.results.activities.Water
			? response.data.results.activities.Water[
					Object.keys(response.data.results.activities.Water)[0]
			  ]
			: null;

		let electricDatasets = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		let waterDatasets = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		let lastTwelveMonths = [
			format(new Date(rawElectricData[0].periodDate), 'MMM yyyy'),
		];

		for (var i = 0; i < 11; i++) {
			let prevMonth = subMonths(
				new Date(rawElectricData[0].periodDate),
				i + 1
			);
			lastTwelveMonths.unshift(format(prevMonth, 'MMM yyyy'));
		}

		console.log('LAST TWELVE MONTHS', lastTwelveMonths);

		for (var i = 0; i < lastTwelveMonths.length; i++) {
			for (var w = 0; w < rawElectricData.length; w++) {
				// electricLabels.unshift(
				// 	format(new Date(rawElectricData[i].periodDate), 'MMM yyyy')
				// );
				if (
					format(
						new Date(rawElectricData[w].periodDate),
						'MMM yyyy'
					) === lastTwelveMonths[i]
				) {
					console.log('SAME', lastTwelveMonths[i]);
					electricDatasets[i] = parseInt(
						rawElectricData[w].readings[0].usage
					);
				}

				electricData = {
					...electricData,
					labels: lastTwelveMonths,
					datasets: [
						{
							backgroundColor: ['#F6C85F'],
							data: electricDatasets,
						},
					],
				};
			}
		}

		// for (var i = 0; i < rawWaterData.length; i++) {
		// 	waterLabels.push(rawWaterData[i].periodDate);
		// 	waterDatasets.push(parseInt(rawWaterData[i].readings[0].usage));
		// 	waterData = {
		// 		...waterData,
		// 		labels: waterLabels,
		// 		datasets: [
		// 			{
		// 				backgroundColor: ['#EE9C03'],
		// 				data: waterDatasets,
		// 			},
		// 		],
		// 	};
		// }

		if (rawWaterData) {
			for (var i = 0; i < lastTwelveMonths.length; i++) {
				for (var w = 0; w < rawWaterData.length; w++) {
					// electricLabels.unshift(
					// 	format(new Date(rawWaterData[i].periodDate), 'MMM yyyy')
					// );
					if (
						format(
							new Date(rawWaterData[w].periodDate),
							'MMM yyyy'
						) === lastTwelveMonths[i]
					) {
						console.log('SAME', lastTwelveMonths[i]);
						waterDatasets[i] = parseInt(
							rawWaterData[w].readings[0].usage
						);
					}

					waterData = {
						...waterData,
						labels: lastTwelveMonths,
						datasets: [
							{
								backgroundColor: ['#EE9C03'],
								data: waterDatasets,
							},
						],
					};
				}
			}
		}

		// const chartData = {
		// 	electric: electricData,
		// 	water: waterData,
		// };

		const chartData = {
			electric: data,
			water: data2,
		};

		console.log('usage chart data', chartData);

		setChartData(chartData);
	} catch {
		console.log('Error getting external provider transactions');
		return { error: 'Error getting external provider transactions' };
	}
};

export default getChartData;
